import { EntitySummaryEntityId, EntitySummaryEntityType } from "@sp-crm/core";
import { InlineFeedbackResponse } from "components/feedback/inline-feedback";

export const AI_SUMMARY_FEEDBACK_OPTIONS = [
    "Inaccurate information",
    "Missing important details",
    "Too long",
    "Too short",
    "Not relevant",
];

export interface AiSummaryShape {
    id: string;
    entityId: EntitySummaryEntityId;
    entityType: EntitySummaryEntityType;
    text: string;
    dateAdded: string;
    provider: string;
    modelUsed?: string;
    tokensUsed?: number;
    editedByName?: string;
    editedAt?: string;
}

export interface AiSummaryState {
    summary: AiSummaryShape | null;
    isLoading: boolean;
    isQueryLoading: boolean;
    isGenerating: boolean;
    isRemoving: boolean;
    isSubmittingFeedback: boolean;
    error: string | undefined;
    feedbackGiven: InlineFeedbackResponse;
    showRemoveButton: boolean;
    generate: () => void;
    updateText: (newText: string) => Promise<boolean>;
    submitPositiveFeedback: () => void;
    startNegativeFeedback: () => void;
    submitNegativeFeedback: (combinedText: string | null) => void;
    removeSummary: () => void;
}
